import { useIntl } from 'react-intl';

import type { DossierRow } from '../../types/dossier.types';
import DossierCard from './DossierCard';
import { $CardList, $EmptyState } from './DossierCardList.styles';
import messages from './messages';

export interface DossierCardListProps {
  dossiers: DossierRow[];
  searchQuery?: string;
  statusFilter?: string;
  dataTestId?: string;
}

const DossierCardList = ({
  dossiers,
  searchQuery = '',
  statusFilter,
  dataTestId = 'dossiers-card-list',
}: DossierCardListProps) => {
  const intl = useIntl();

  if (dossiers.length === 0) {
    const hasSearch = searchQuery.trim() !== '';
    const hasStatusFilter = statusFilter !== undefined;

    const emptyMessage =
      hasSearch && hasStatusFilter
        ? messages.emptySearchAndFilter
        : hasSearch
          ? messages.emptySearch
          : hasStatusFilter
            ? messages.emptyFilter
            : messages.emptyList;

    return (
      <$EmptyState data-testid={`${dataTestId}-empty`}>
        {intl.formatMessage(emptyMessage)}
      </$EmptyState>
    );
  }

  return (
    <$CardList data-testid={dataTestId}>
      {dossiers.map((dossier) => (
        <DossierCard key={dossier.numeroDossier} dossier={dossier} />
      ))}
    </$CardList>
  );
};

export default DossierCardList;
